// @charset "UTF-8";
import React, { useContext, useEffect } from "react";
import { Box, Container, IconButton, Button, Grid, Typography } from "@mui/material";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import logo from "../../../src/assets/img/logos/logo-espol.png";
import { themePalette } from "../../config/theme.config";
import { TbSearch } from "react-icons/tb";
import { BiWorld } from "react-icons/bi";
import { I18nContext } from "../../I18nProvider";
import { useAppSelector } from "../../redux/hooks";

export const HomePage: React.FC<{}> = () => {
    const context = useContext(I18nContext);
    const navigate = useNavigate();
    const location = useLocation();
    const { isAuth, rol } = useAppSelector((state) => state.authReducer);

    useEffect(() => {
        console.log("XD");
        console.log(rol);
    }, []);

    if (context === null) {
        throw new Error(
            "The I18n context is not initialized. Make sure you have the provider set up correctly."
        );
    }

    // Lista de botones (3 arriba, 3 abajo)
    const navButtons = [
        ...(isAuth && rol == "ADMIN RANKING INVESTIGACIÓN"
            ? [{ label: "Generar Ranking", path: "/Ranking/consulta" }]
            : []),
        { label: context.t.translate("home.uAcademica") || "Unidades Académicas", path: "unidades" },
        { label: context.t.translate("home.cInvestigacion") || "Centros de Investigación Institucionales", path: "centros" },
        { label: context.t.translate("home.estadisticas") || "Estadísticas", path: "estadisticas" },
        { label: "H Index Top", path: "hindextop" },
        { label: context.t.translate("home.ods") || "ODS", path: "odss" },
        ...(isAuth && (rol==="ADMIN RANKING INVESTIGACIÓN"||rol==="LECTOR RANKING INVESTIGACIÓN" )
            ? [{ label: "Visualizar Ranking", path: "/Ranking/visualizar" }]
            : []),
    ];


    return (
        <Container maxWidth="lg" sx={{ textAlign: "center" }}>
            <Box >
                {/* Logo institucional */}
                <Grid container justifyContent="center" alignItems="center">
                    <Grid item xs={10} sm={6} md={5}>
                        <Box
                            component="img"
                            src={logo}
                            alt="ESPOL"
                            sx={{ width: "100%", maxWidth: 360, height: "auto", mt: 1, mb: 1 }}
                        />
                    </Grid>
                </Grid>

                {/* Título */}
                <Typography
                    variant="h5"
                    component="h2"
                    sx={{
                        fontWeight: 700,
                        color: themePalette.NAVCOLOR || "#1e293b",
                        mb: 3,
                    }}
                >
                    {context.t.translate("home.repoInv")}
                </Typography>

                {/* Accesos rápidos (Iconos con fondo circular de la imagen) */}
                <Box sx={{ display: "flex", justifyContent: "center", gap: 3, mb: 4 }}>
                    <IconButton
                        onClick={() => navigate("colaboracion")}
                        sx={{
                            backgroundColor: "#f8fafc",
                            p: 2,
                            borderRadius: "50%",
                            border: "1px solid #e2e8f0",
                            color: themePalette.NAVCOLOR,
                            boxShadow: "0 2px 6px rgba(0,0,0,0.04)",
                            transition: "all 0.2s ease-in-out",
                            "&:hover": {
                                backgroundColor: themePalette.NAVCOLOR,
                                color: "#ffffff",
                                transform: "translateY(-2px)",
                                boxShadow: "0 6px 14px rgba(0,0,0,0.1)",
                            },
                        }}
                    >
                        <BiWorld size={46} />
                    </IconButton>

                    <IconButton
                        onClick={() => navigate("busqueda")}
                        sx={{
                            backgroundColor: "#f8fafc",
                            p: 2,
                            borderRadius: "50%",
                            border: "1px solid #e2e8f0",
                            color: themePalette.NAVCOLOR,
                            boxShadow: "0 2px 6px rgba(0,0,0,0.04)",
                            transition: "all 0.2s ease-in-out",
                            "&:hover": {
                                backgroundColor: themePalette.NAVCOLOR,
                                color: "#ffffff",
                                transform: "translateY(-2px)",
                                boxShadow: "0 6px 14px rgba(0,0,0,0.1)",
                            },
                        }}
                    >
                        <TbSearch size={46} />
                    </IconButton>
                </Box>

                {/* Contenedor Grid 3x2 con bordes ovalados exactos */}
                <Container maxWidth="md">
                    <Grid container spacing={2.5} justifyContent="center" alignItems="center">
                        {navButtons.map((btn, index) => {
                            const isActive = location.pathname.includes(btn.path);
                            return (
                                <Grid item xs={12} sm={6} md={4} key={`${btn.path}-${index}`}>
                                    <Button
                                        fullWidth
                                        variant="outlined"
                                        onClick={() => navigate(btn.path)}
                                        sx={{
                                            height: 65,
                                            px: 2,
                                            borderRadius: "32px", // Forma de píldora redondeada
                                            textTransform: "none",
                                            fontSize: "0.88rem",
                                            fontWeight: 600,
                                            lineHeight: 1.25,
                                            color: isActive ? "#ffffff !important" : themePalette.NAVCOLOR,
                                            backgroundColor: isActive ? themePalette.NAVCOLOR : "#ffffff",
                                            borderColor: isActive ? themePalette.NAVCOLOR : "#cbd5e1",
                                            transition: "all 0.2s ease",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            textAlign: "center",
                                            "&:hover": {
                                                backgroundColor: isActive ? themePalette.NAVCOLOR : "#f8fafc",
                                                borderColor: themePalette.NAVCOLOR,
                                                transform: "translateY(-2px)",
                                                boxShadow: "0 4px 10px rgba(0,0,0,0.06)",
                                            },
                                        }}
                                    >
                                        {btn.label}
                                    </Button>
                                </Grid>
                            );
                        })}
                    </Grid>
                </Container>
            </Box>

            {/* Subvistas / Outlet */}
            <Box
                sx={{
                    marginTop: "30px",
                    paddingTop: "20px",
                    paddingBottom: "20px",
                    boxShadow: location.pathname === "/" ? 0 : 2,
                    borderRadius: "8px",
                }}
            >
                <Outlet />
            </Box>
        </Container>
    );
};